import { writable } from "svelte/store";

// General

// ConceptReport
export const storedSignatureHash = writable(null);
export const currentlyEditingReport = writable(false);
export const exportContent = writable(true);
export const exportTitle = writable(null);
export const exportType = writable(null);
export const exportSigner = writable(null);
export const exportDate = writable(null);
export const prefilledReportContent = writable(null);
export const storedEditorContent = writable(null);
export const currentBrowser = writable(null);

// AdrTool

